import { Validators } from '@angular/forms';
import { StepConfig } from '../../shared/components/formbuilder/field-config';
import { getAllLicenseOptions } from './license-options.config';

export const EOI_FORM_CONFIG: StepConfig[] = [
  {
    title: '',
    subtitle: '',
    fields: [
      {
        name: 'companyName',
        type: 'text',
        label: 'Company Name',
        placeholder: 'Enter your company name',
        validators: [Validators.required, Validators.minLength(2)],
        hint: 'Full legal name of your company'
      },
      {
        name: 'tinNumber',
        type: 'text',
        label: 'Tax Identification Number',
        placeholder: 'Enter Tax Identification Number',
        validators: [Validators.required, Validators.minLength(5)],
        hint: 'Your company Tax Identification Number'
      },
      {
        name: 'applicantEmail',
        type: 'email',
        label: 'Contact Email',
        placeholder: 'Enter your email address',
        validators: [Validators.required, Validators.email],
        hint: 'Email address for correspondence about your application'
      },
      {
        name: 'selectedLicense',
        type: 'select',
        label: 'Licence Type',
        placeholder: 'Select the licence you want to apply for',
        validators: [Validators.required],
        hint: 'Choose the type of licence you wish to apply for',
        options: getAllLicenseOptions()
      },
      {
        name: 'comments',
        type: 'textarea',
        label: 'Additional Comments',
        placeholder: 'Any additional information or specific requirements',
        hint: 'Optional: Provide any additional details about your licence application'
      }
    ]
  }
];
